import Icon from "@shared/components/ui-kit/icons/Icon.web";
import Flex from "@shared/components/ui-kit/layout/Flex/Flex.web";
import Menu from "@shared/components/ui-kit/overlays/Menu/Menu.web";
import { useChangeLanguage } from "@shared/hooks/useChangeLanguage/useChangeLanguage";
import { navigationLocales } from "@shared/modules/navigation/constants/navigation-translations";
import { useNavBarActions } from "@shared/modules/navigation/hooks/useNavBarActions";

interface NavBarLocaleMenuProps {
  transparent?: boolean;
}

const NavBarLocaleMenu = ({ transparent = false }: NavBarLocaleMenuProps) => {
  const { isReady, languageCode, language } = useChangeLanguage();
  const { goToLocale } = useNavBarActions();

  if (!isReady) {
    return null;
  }

  const buttonLabel = languageCode?.toUpperCase();
  const ariaLabel = language;

  const handleSelect = (details: { value: string }) => {
    goToLocale(details.value);
  };

  return (
    <Menu onSelect={handleSelect}>
      <Menu.Button
        data-testid="navbar-locale-menu"
        aria-label={ariaLabel}
        h="element.3xl"
        px="md"
        borderRadius="sm"
        transition="all 0.2s"
        _hover={
          transparent
            ? {
                _light: { bg: "whiteAlpha.400" },
                _dark: { bg: "whiteAlpha.200" },
              }
            : {
                _light: { bg: "gray.300" },
                _dark: { bg: "whiteAlpha.200" },
              }
        }
      >
        <Flex
          justifyContent="center"
          alignItems="center"
          gap="2xs"
          fontWeight="400"
          color="fg"
          fontSize="md"
        >
          <span suppressHydrationWarning>{buttonLabel}</span>
          <Icon.ChevronDown color="fg" boxSize="element.md" />
        </Flex>
      </Menu.Button>
      <Menu.List>
        {Object.keys(navigationLocales).map((locale) => {
          const { label: optionLabel } = navigationLocales[locale];
          const isCurrentLanguage = languageCode === locale;
          return (
            <Menu.Item
              key={locale}
              value={locale}
              opacity={isCurrentLanguage ? 0.5 : 1}
              cursor={isCurrentLanguage ? "default" : "pointer"}
              pointerEvents={isCurrentLanguage ? "none" : "auto"}
            >
              {optionLabel}
            </Menu.Item>
          );
        })}
      </Menu.List>
    </Menu>
  );
};

export default NavBarLocaleMenu;
